






import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { readShowProgress } from '@/store/main/accessors';

@Component
export default class NotificationsManager extends Vue {
  public overlay: boolean = false;

  public get showProgress() {
    return readShowProgress(this.$store);
  }

  @Watch('showProgress')
  public onShowProgressChange(showProgress: boolean) {
    this.overlay = showProgress;
  }
}
